import bem from 'utils/bem';

export const block = bem('aspect-ratio-selector');
